export default __webpack_public_path__ + "static/media/mechanic.0009e7dd.jpg";